import { useSelector } from 'react-redux';

import featureFlagConstants from '~/common/helpers/featureFlagConstants';
import useFeatureFlag from '~/common/hooks/useFeatureFlag';
import { StoreRootState } from '~/scenes/Governance/types/StoreRootState';

export const useIsAutoscaling = () => {
  const { realms } = useSelector<
    StoreRootState,
    Pick<StoreRootState, 'realms'>
  >(state => state);

  const { treatments } = useFeatureFlag([
    featureFlagConstants.RUN_DISABLE_ITAU_AUTOSCALING
  ]);

  const isAutoscalingDisabled =
    treatments[featureFlagConstants.RUN_DISABLE_ITAU_AUTOSCALING]?.treatment ===
    'on';

  return (
    realms?.getRealm?.licenseModel === 'CONSUMPTION_BASED_MODEL' ||
    (realms?.getRealm?.licenseModel === 'PRODUCTION_SUBSCRIPTION' &&
      !isAutoscalingDisabled)
  );
};
